module.exports = __webpack_public_path__ + "static/media/github.f35b032f.png";